import {
    GoogleAuthProvider,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    signInWithPopup,
    sendPasswordResetEmail as sendResetEmail,
} from "firebase/auth";
import { auth } from "./firebaseConfig"; // Import the Firebase authentication object from FirebaseConfig
//   import { updateUserInFirestore } from "./FirebaseStore";

// Export a function to handle user sign-up
export const handleSignUp = async (email, password, fullName) => {
    try {
        const userCredential = await createUserWithEmailAndPassword(
            auth,
            email,
            password
        );
        const { user } = userCredential;

        // Update or create user in Firestore
        //   await updateUserInFirestore(user, { email, fullName });
    } catch (error) {
        // Handle the error or display an error message to the user.
        console.error("Sign-up error:", error);
    }
};

// Export a function to handle user sign-in
export const handleSignIn = async (email, password) => {
    try {
        const userCredential = await signInWithEmailAndPassword(
            auth,
            email,
            password
        );
        const { user } = userCredential;

        // Update user in Firestore on sign-in (if needed)
        //   await updateUserInFirestore(user, { email });
    } catch (error) {
        // Handle the error or display an error message to the user.
        console.error("Sign-in error:", error);
    }
};